import React from 'react';
import GetRatesV2 from '../GetRatesV2';
import { Box, Grid, Typography, styled } from '@mui/material';
import SbImage from '../../components/Image';
// import Image from '../../components/Image';
import { useSelector } from 'react-redux';
import { RootStateType } from '@Store';

const Root = styled(Grid)(({ theme }) => ({
  position: 'relative',
  flex: 1,
  backgroundColor: 'white',
  minHeight: 'var(--layout-height)',
  // Hide background from here — do it via pseudo-element instead
  '&::before': {
    content: "''",
    position: 'absolute',
    inset: 0,
    background: "url('/images/login/Group.png')",
    backgroundPositionX: '1000px',
    backgroundSize: '934px',
    backgroundRepeatX: 'no-repeat',
    backgroundRepeat: 'no-repeat',
    filter: `brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%) drop-shadow(0 0 0 ${theme.palette.secondary.main})`,
    zIndex: 0,
  },

  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
}));

const Header = styled(Grid)({
  marginTop: '60px',
});

function GetRatesWithoutLogin() {
  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '', logo = '/images/login/logo.png' } = organizationData || {};
  return (
    <Root container>
      <Grid item xs={12} md={10}>
        <Header container justifyContent={'start'} alignItems={'center'}>
          <SbImage src={logo} alt="logo" style={{ width: '208px', maxHeight: '121px' }} />
          <Typography
            variant="h4"
            style={{ fontWeight: '700', color: 'var(--mui-palette-primary-main)', paddingLeft: '1.5rem' }}
          >
            Welcome to {name}
          </Typography>
        </Header>
        <Box paddingLeft="3rem" sx={{ width: '90%' }}>
          <GetRatesV2 />
        </Box>
      </Grid>
      {/* <Grid item xs={2}> */}
      {/* <SbImage src="/images/login/Group.png" alt="logo" style={{ display: 'block', margin: '0 auto' }} /> */}
      {/* </Grid> */}
      <Box
        position={'absolute'}
        top={'0'}
        right={'0'}
        sx={{
          height: '100%',
          display: {
            xs: 'none',
            lg: 'block',
          },
        }}
      >
        {/* <Image
          src="/images/wave.svg"
          alt="Wave"
          style={{ width: '100%', height: '100%', position: 'sticky', right: '0' }}
        /> */}
      </Box>
    </Root>
  );
}

export default GetRatesWithoutLogin;
